'use client';

import {
  Button,
  Card,
  Center,
  Container,
  Divider,
  Grid,
  HoverCard,
  Table,
  Text,
  Title,
} from '@mantine/core';
import { IconCloudDown, IconDownload } from '@tabler/icons-react';
import { useTranslation } from '@/i18n/client';
import classes from './Download.module.css';

export function Download() {
  const { t } = useTranslation('download');
  return (
    <Container size='xl' mt={100} mb={50}>
      <Card withBorder px={20}>
        <Center>
          <Title order={1}>{t('download.title')}</Title>
        </Center>
        <Grid my={30}>
          <Grid.Col span={{ base: 12, md: 6 }} px={30}>
            <Center>
              <h2 className={classes.cardTitle} style={{ margin: 0 }}>
                {t('download.launcher.title')}
              </h2>
            </Center>
            <Center>
              <Text style={{ textAlign: 'center' }} mt={15}>
                {t('download.launcher.description')}
              </Text>
            </Center>
            <Center>
              <Button
                mt={15}
                variant='filled'
                size='lg'
                rightSection={<IconDownload size={20} />}
                onClick={() => window.open('https://tera-asura.ru/static/files/launcher.exe')}
              >
                {t('download.launcher.button')}
              </Button>
            </Center>
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6 }} px={30}>
            <Center>
              <h2 className={classes.cardTitle} style={{ margin: 0 }}>
                {t('download.installer.title')}
              </h2>
            </Center>
            <Center>
              <Text mt={15} style={{ textAlign: 'center' }}>
                {t('download.installer.description')}
              </Text>
            </Center>
            <Center>
              <HoverCard shadow='md'>
                <HoverCard.Target>
                  <Button
                    mt={15}
                    variant='filled'
                    size='lg'
                    color='green'
                    rightSection={<IconCloudDown size={20} />}
                    onClick={() =>
                      window.open('https://tera-asura.ru/static/files/TERA-Setup.torrent')
                    }
                  >
                    {t('download.installer.button')}
                  </Button>
                </HoverCard.Target>
                <HoverCard.Dropdown>
                  <Text size='sm'>{t('download.thanks')}</Text>
                </HoverCard.Dropdown>
              </HoverCard>
            </Center>
          </Grid.Col>
        </Grid>
        <Divider />
        <Center mt={20}>
          <Title order={1}>{t('software.title')}</Title>
        </Center>
        <Grid my={30}>
          <Grid.Col span={{ base: 12, md: 4 }} px={30}>
            <Center>
              <Title className={classes.cardTitle} style={{ margin: 0 }}>
                {t('software.nvidia')}
              </Title>
            </Center>
            <Center>
              <Button
                mt={20}
                variant='filled'
                size='md'
                color='#76b900'
                rightSection={<IconCloudDown size={20} />}
                onClick={() => window.open('https://www.nvidia.com/en-us/software/nvidia-app/')}
              >
                {t('software.button')}
              </Button>
            </Center>
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 4 }} px={30}>
            <Center>
              <h2 className={classes.cardTitle} style={{ margin: 0 }}>
                {t('software.amd')}
              </h2>
            </Center>
            <Center>
              <Button
                mt={20}
                variant='filled'
                size='md'
                color='#bd0000'
                rightSection={<IconCloudDown size={20} />}
                onClick={() =>
                  window.open('https://www.amd.com/en/products/software/adrenalin.html')
                }
              >
                {t('software.button')}
              </Button>
            </Center>
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 4 }} px={30}>
            <Center>
              <h2 className={classes.cardTitle} style={{ margin: 0 }}>
                {t('software.directx')}
              </h2>
            </Center>
            <Center>
              <Button
                mt={20}
                variant='filled'
                size='md'
                color='blue'
                rightSection={<IconCloudDown size={20} />}
                onClick={() =>
                  window.open('https://www.microsoft.com/en-us/download/details.aspx?id=35')
                }
              >
                {t('software.button')}
              </Button>
            </Center>
          </Grid.Col>
        </Grid>
        <Divider />
        <Center mt={20}>
          <Title order={1}>{t('requirements.title')}</Title>
        </Center>
        <Center>
          <Table
            mt={30}
            style={{ maxWidth: '900px' }}
            variant='vertical'
            layout='fixed'
            withTableBorder
          >
            <Table.Thead>
              <Table.Tr>
                <Table.Th></Table.Th>
                <Table.Th>{t('requirements.minimal.title')}</Table.Th>
                <Table.Th>{t('requirements.recommend.title')}</Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              <Table.Tr>
                <Table.Th>{t('requirements.description.0')}</Table.Th>
                <Table.Td>{t('requirements.minimal.description.0')}</Table.Td>
                <Table.Td>{t('requirements.recommend.description.0')}</Table.Td>
              </Table.Tr>
              <Table.Tr>
                <Table.Th>{t('requirements.description.1')}</Table.Th>
                <Table.Td>{t('requirements.minimal.description.1')}</Table.Td>
                <Table.Td>{t('requirements.recommend.description.1')}</Table.Td>
              </Table.Tr>
              <Table.Tr>
                <Table.Th>{t('requirements.description.2')}</Table.Th>
                <Table.Td>{t('requirements.minimal.description.2')}</Table.Td>
                <Table.Td>{t('requirements.recommend.description.2')}</Table.Td>
              </Table.Tr>
              <Table.Tr>
                <Table.Th>{t('requirements.description.3')}</Table.Th>
                <Table.Td>{t('requirements.minimal.description.3')}</Table.Td>
                <Table.Td>{t('requirements.recommend.description.3')}</Table.Td>
              </Table.Tr>
              <Table.Tr>
                <Table.Th>{t('requirements.description.4')}</Table.Th>
                <Table.Td>{t('requirements.minimal.description.4')}</Table.Td>
                <Table.Td>{t('requirements.recommend.description.4')}</Table.Td>
              </Table.Tr>
            </Table.Tbody>
          </Table>
        </Center>
      </Card>
    </Container>
  );
}

export default Download;
